import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteEducationalUnit($id: Int!) {
    deleteEducationalUnit(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteEducationalUnit: {
    id?: number;
  };
}
